import { toJS } from 'mobx';

import { IndividualReport } from 'chaika-frontend-types/frontend-cms';
import { IndividualReportType } from 'chaika-enums';

interface IndividualReportTemplateStrategyNotSelected {
    selectIndividualReport(individualReport: IndividualReport): IndividualReportTemplateStrategySelected;
}

interface IndividualReportTemplateStrategySelected {
    getTemplateData<T extends object>(params: T): object;
}

export class IndividualReportTemplateStrategy
    implements IndividualReportTemplateStrategyNotSelected, IndividualReportTemplateStrategySelected
{
    public static getBuilder(): IndividualReportTemplateStrategyNotSelected {
        return new IndividualReportTemplateStrategy();
    }

    private individualReport?: IndividualReport;

    private constructor() {
        this.individualReport = undefined;
    }

    public selectIndividualReport(individualReport: IndividualReport): IndividualReportTemplateStrategySelected {
        this.individualReport = individualReport;
        return this;
    }

    public getTemplateData<T extends object>(params: T): object {
        switch (this.individualReport?.type) {
            case IndividualReportType.Entry:
            case IndividualReportType.PaymentAct:
            case IndividualReportType.PatientReservations:
                return this.getDataAsObject(params);
            default:
                return new Error('Individual report should be set');
        }
    }

    private getDataAsObject<T extends object>(params: T): object {
        return toJS(params);
    }
}
